export default __webpack_public_path__ + "static/media/pictogramThumbUp48.ce6fd231.svg";